// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const pollRuleApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addPollRule: builder.mutation({
      query: (data) => {
        return {
          url: "poll-rule",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updatePollRule: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `poll-rule/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deletePollRule: builder.mutation({
      query: (id) => {
        return {
          url: `poll-rule/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllPollRules: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `poll-rule?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddPollRuleMutation,
  useUpdatePollRuleMutation,
  useDeletePollRuleMutation,
  useGetAllPollRulesQuery,
} = pollRuleApi;
